import MainApp from "./MainApp";
import React , {useState} from "react";
import './App.css'
import Header from "./header";
import Btn from "./Btn";
import Footer from "./Footer";

const App = () => {
  
  
  const [value , setValue] = useState('');  

  const textAreaChange = (event) => {
      setValue(event.target.value);
  }
  const clearText = () => {
    setValue('');
  }
  const copyText = () => {
    window.navigator.clipboard.writeText(value);
    alert('Text Copied!')
  }
  const removeSpace = () => {
    setValue((value.split(/[ ]+/)).join(" "));
  }
  const capText = () => {
    setValue(value.toLocaleLowerCase().replace(/\b[a-z]/g, (letter) => {
      return letter.toUpperCase();
    }));
  }

  return (
    <div>
      <Header
      title='text master'
      text='get amazing text utilities in a single application for free.'
      />

      <MainApp 
      textAreaChange = {textAreaChange} 
      tAClass = 'tA'
      tAValue={value} 
      chars={value.length}
      words={ (value.split(' ').length) - 1 }
      time={0.008 * ((value.split(' ').length - 1 === 0) ? 0 : value.split(' ').length)}
      />
      <div className="buttonGroup">
        <Btn 
        text='Convert Uppercase'
        clicked={()=>setValue(value.toUpperCase())}
        />
      <Btn 
      text='Convert lowercase'
      clicked={()=>setValue(value.toLowerCase())}
      />
      <Btn 
      text='Remove extra spaces'
      clicked={removeSpace}
      />
      <Btn 
      text='Capitalize Text'
      clicked={capText}
      />
      <Btn 
      text='Clear Text'
      clicked={clearText}
      />
      <Btn 
      text='Copy Text'
      clicked={copyText}
      />
      </div>
      <Footer 
      owner="Asad Ali"
      linkfb='https://www.facebook.com/asadali.mehar.14'
      linkwa="https://wa.me/+923040218223"
      linkemail='https://mail.google.com/mail/u/0/#sent?compose=CllgCHrhThXjCmRTjSLFMFzqVGrZCQMjVTfqnvmXzgJFQJQSCKMkTVxDcwjtjKhTtXdrHjBSmSV'
      linkmess='https://www.messenger.com/t/100071241664557/'
      />
    </div>
  );
}
export default App;